export const DASHBOARD_MANAGE_DRAWER_EMPTY_CONTAINER_OFFSET = 46;
